import { FC, PropsWithChildren } from 'react';
import { NavPanel } from './NavPanel';
import { Layout as AntdLayout } from 'antd';
import classes from './Layout.module.scss';
import { Content, Header } from 'antd/lib/layout/layout';
import { ChatGlobalPanel } from '@app/chat/widgets/Chat.Global';
import { useObservable } from '@app/base';
import { GLOBAL_CHAT_OPEN_OBSERVABLE, GLOBAL_CHAT_OPEN_USER_ID_OBSERVABLE } from '@app/chat/utils';
import classNames from 'classnames';
import { useUserContextSelector } from '@app/main/utils';
import { Page, useMobile } from '@app/ui';
import { ConsentSignatureEnforcerWidget } from '@app/main/widgets/Consents.Common';
import { ScheduleAppointmentModalWidget } from '@app/main/widgets/Schedule.Common';
import React from 'react';

const LayoutComponent: FC<PropsWithChildren<object>> = ({ children }) => {
  const [chatId] = useObservable(GLOBAL_CHAT_OPEN_OBSERVABLE);
  const [pinedChatUserId] = useObservable(GLOBAL_CHAT_OPEN_USER_ID_OBSERVABLE);
  const { isTablet } = useMobile();
  const userId = useUserContextSelector((x) => x.id);
  const isUserChat = chatId && pinedChatUserId === userId;

  return (
    <AntdLayout className={classes.layout} ref={Layout.ref}>
      <Header className={classes.header}>
        <NavPanel />
      </Header>
      <Content className={classNames(classes.main, { [classes.openChat]: isUserChat })}>
        <Page.Context forceFullWidth={!!chatId || isTablet}>
          {children}
          {isUserChat && <ChatGlobalPanel id={chatId} />}
          <ConsentSignatureEnforcerWidget />
        </Page.Context>
      </Content>
      <ScheduleAppointmentModalWidget />
    </AntdLayout>
  );
};

export const Layout = Object.assign(LayoutComponent, {
  ref: React.createRef<HTMLElement>() as React.MutableRefObject<HTMLElement>,
});
